import { useQuery } from "@tanstack/react-query";
import { buildUrl, toastServerError } from "helpers";
import { ApiError, ApiServiceError, instance } from "libs/api";

import { AiAssistantStats } from "../../aiAgents.types";
import {
  AI_ASSISTANTS_QUERY_KEY,
  AiAssistantSubRoute,
  ApiRoutesAiAssistants
} from "../../constants/enums";

const statsKey = (assistantId: string) => [
  AI_ASSISTANTS_QUERY_KEY,
  "stats",
  assistantId
];

export const useGetAssistantStats = (assistantId: string | undefined) => {
  const query = useQuery<AiAssistantStats, ApiServiceError<ApiError>>({
    queryKey: statsKey(assistantId ?? ""),
    queryFn: async () =>
      await instance.get(
        buildUrl(
          ApiRoutesAiAssistants.Assistants,
          assistantId!,
          AiAssistantSubRoute.Stats
        )
      ),
    enabled: Boolean(assistantId),
    onError: toastServerError
  });

  return { stats: query.data, ...query };
};
